export default __webpack_public_path__ + "static/media/download-section-mashroom.cf965417.webp";